import type { SagaIterator } from 'redux-saga'
import { put, select } from 'redux-saga/effects'

import { AIInternalActions } from '../actions'
import { selectAICancelTokenSource } from '../selectors'

export function* stopMessage(): SagaIterator {
  const cancelTokenSource = yield select(selectAICancelTokenSource)

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Request cancelled by user')
  }

  window.dispatchEvent(new Event('CancelAiGeneration'))

  yield put(AIInternalActions.resetGeneration())
}
